export default __webpack_public_path__ + "static/media/Baby14.bdee8b62.gif";